<template>
  <div>
    <!-- BEGIN: Subheader -->
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Masraf</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>

    <!-- END: Subheader -->
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Form-->
          <form class="m-form m-form--fit m-form--label-align-right">
            <!--begin::Portlet-->
            <div class="m-portlet">
              <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                  <div class="m-portlet__head-title">
                    <span class="m-portlet__head-icon m--hide">
                      <i class="la la-gear"></i>
                    </span>
                    <h3 class="m-portlet__head-text">
                      <a
                        :href="'#/expenses'"
                        class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                      >
                        <i class="la la-angle-left"></i>
                      </a>
                      Masraf Ekle
                    </h3>
                  </div>
                </div>
              </div>

              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">KOD :</label>
                  <div class="col-lg-8">
                    <input
                      type="text"
                      class="form-control m-input"
                      placeholder="Kod..."
                      :class="{
                        'is-invalid': $v.expense.expenseCode.$error
                      }"
                      v-model="expense.expenseCode"
                    />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">MASRAF SAHİBİ :</label>
                  <div class="col-lg-8">
                    <input
                      type="text"
                      class="form-control m-input"
                      placeholder="Masraf Sahibi..."
                      :class="{
                        'is-invalid': $v.expense.ownerUser.$error
                      }"
                      v-model="expense.ownerUser"
                      :disabled="true"
                    />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">MASRAF TARİHİ :</label>
                  <div class="col-lg-8">
                    <datepicker
                      type="text"
                      format="dd.MM.yyyy"
                      placeholder="Masraf Tarihi..."
                      input-class="form-control"
                      :class="{
                        'is-invalid': $v.expense.requestDate.$error
                      }"
                      v-model="expense.requestDate"
                    ></datepicker>
                  </div>
                </div>



                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">TUTAR :</label>
                  <div class="col-lg-8">
                    <input
                      type="text"
                      class="form-control m-input"
                      :class="{ 'is-invalid': $v.expense.amount.$error }"
                      placeholder="Tutar..."
                      v-model="expense.amount"
                      :disabled="true"
                    />
                  </div>
                </div>
                  <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">AÇIKLAMA :</label>
                  <div class="col-lg-8">
                    <input
                      type="text"
                      class="form-control m-input"
                      placeholder="Açıklama..."
                      :class="{
                        'is-invalid': $v.expense.description.$error
                      }"
                      v-model="expense.description"
                    />
                  </div>
                </div>

                <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <!-- <div class="row">
                    <div class="col-lg-12">
                      <button v-if="approveItem != null && approveItem.id != 0" type="button" @click="approve()" class="btn m-btn--pill btn-primary">Onayla</button>
                      <button v-if="approveItem != null && approveItem.id != 0" type="button" @click="reject()" class="btn m-btn--pill btn-primary">Reddet</button>
                      <button v-if="approveItem == null || approveItem.id == 0" type="button" @click="advance.id==0?create():update()" class="btn m-btn--pill btn-primary">Kaydet</button>
                    </div>
                  </div> -->
                </div>
              </div>
              </div>
              
              <!--end::Form-->
            

            <!--end::Portlet-->

            <!--begin::Portlet-->
            
              <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                  <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">Masraf Detayları</h3>
                  </div>
                </div>

                <div class="m-portlet__head-tools">
                  <ul class="m-portlet__nav">
                    <li class="m-portlet__nav-item">
                      <button
                        @click="addNewEmptyDetail()"
                        class="spbtn"
                        type="button"
                      >
                        <span>
                          <i class="la la-plus"></i>
                          <span>Yeni Ekle</span>
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="m-portlet__body">
                <div class="table-responsive">
                  <!--begin::Table-->
                  <table class="table">
                    <!--begin::Thead-->
                    <thead>
                      <tr>
                        <td class="m-widget11__label">#</td>
                        <td class="m-widget11__app">TARİH</td>
                        <td class="m-widget11__app">MASRAF MERKEZİ</td>
                        <td class="m-widget11__app">PROJE</td>
                        
                        <td class="m-widget11__app">FİYAT</td>
                        
                        <td class="m-widget11__label">AÇIKLAMA</td>
                        <td></td>
                      </tr>
                    </thead>

                    <!--end::Thead-->

                    <!--begin::Tbody-->
                    <tbody v-if="expense.details && expense.details.length">
                      <tr v-for="(v, index) in $v.expense.details.$each.$iter" v-bind:key="index">
                        <td>0</td>
                        <td>
                          <datepicker
                            type="text"
                            format="dd.MM.yyyy"
                            placeholder="Tarih..."
                            :class="{
                              'is-invalid': !v.date.required
                            }"
                            input-class="form-control"
                            v-model="v.date.$model"
                          ></datepicker>
                        </td>

                        <td>
                          <select
                            class="form-control m-input"
                            :class="{
                              'is-invalid':
                                !v.expenseCenterId.decimal ||
                                !v.expenseCenterId.required
                            }"
                            v-model="v.expenseCenterId.$model"
                          >
                            <option value="null">Masraf Merkezi Seçiniz</option>
                            <option
                              v-for="option in expenseCenters"
                              :key="option.id"
                              :value="option.id"
                            >{{ option.description }}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            class="form-control m-input"
                            :class="{
                              'is-invalid':
                                !v.projectId.decimal || !v.projectId.required
                            }"
                            v-model="v.projectId.$model"
                          >
                            <option value="null">Proje Seçiniz</option>
                            <option
                              v-for="option in projects"
                              :key="option.id"
                              :value="option.id"
                            >{{ option.description }}</option>
                          </select>
                        </td>
                        
                        <td>
                          <input
                            type="text"
                            class="form-control m-input"
                            placeholder="Fiyat..."
                            :class="{
                              'is-invalid':
                                !v.amount.required || !v.amount.decimal
                            }"
                            v-model.number="v.amount.$model"
                            @change="updateHeaderAmount"
                          />
                        </td>
                                                

                        
                        <td>
                          <input
                            type="text"
                            class="form-control m-input"
                            placeholder="Açıklama..."
                            :class="{
                              'is-invalid': !v.description.required
                            }"
                            v-model="v.description.$model"
                          />
                        </td>
                        <td>
                          <!-- <a
                            href="#"
                            class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill btn-lg"
                            title="Düzenle"
                          >
                            <i class="la la-edit"></i>
                          </a>-->

                          <button
                            @click="deleteDetailItem(v.$model)"
                            class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill btn-lg"
                            title="Sil"
                          >
                            <i class="la la-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>

                    <!--end::Tbody-->
                  </table>

                  <!--end::Table-->
                </div>
              <!-- </div> -->

              <!--end::Form-->
            </div>

            <!--end::Portlet-->

            <!--begin::Portlet-->
            <!-- <div class="m-portlet"> -->
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                       <button
                        v-if="approveItem == null || approveItem.id == 0 || this.$store.getters.user.authorities.includes('Admin') "
                        @click="expense.id==0?create():update()"
                        type="button"
                        class="spbtn"
                      >Kaydet</button>
                      
                      <button
                        v-if="approveItem != null  && approveItem.id != 0"
                        type="button"
                        @click="approve()"
                        class="spbtn"
                      >Onayla</button>
                      <button
                        v-if="approveItem != null && approveItem.id != 0"
                        type="button"
                        @click="reject()"
                        class="spbtn"
                      >Reddet</button>

                     
                    </div>
                  </div>
                </div>
              </div>

              <!--end::Form-->
            </div>

            <!--end::Portlet-->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import datepicker from "vuejs-datepicker";
import { required, decimal } from "vuelidate/lib/validators";
import { _getAllExpenseCenterCombo } from "../../services/ExpenseCenterService";
import { _getAllProjectCombo } from "../../services/ProjectService";
import {
  _getById,
  _getDetailByExpenseId,
  _create,
  _update
} from "../../services/ExpenseService";
import {
  _approve,
  _getMyApproveIfExist,
  _reject
} from "../../services/ApproveService";

export default {
  data() {
    return {
      projects: [],
      expenseCenters: [],
      expense: {},
      approveItem: {
        id: 0,
        approveReferenceType: null,
        approvementStatusEnum: null,
        referenceId: 0
      }
    };
  },
  created() {
    this.loadProjects();
    this.loadExpenseCenter();
    this.start();
    this.getMyApproveIfExist();
  },
  components: {
    datepicker
  },
  validations: {
    expense: {
      expenseCode: { required },
      description: { required },
      requestDate: { required },
      amount: { required, decimal },
      ownerUser: { required },
      ownerUserId: { required },
      details: {
        $each: {
          date: { required },
          expenseCenterId: { decimal, required },
          projectId: { decimal, required },
          description: { required },
          amount: { required, decimal }
        }
      }
    }
  },
  methods: {
    start() {
      if (Number(this.$route.params.id) != 0) {
        this.expense.id = Number(this.$route.params.id);
        _getById(this.expense.id).then(res => {
          if (res.data.success) {
            this.expense = res.data.data;
            _getDetailByExpenseId(this.expense.id).then(response => {
              this.$set(this.expense, "details", response.data.data);
            });
          }
        });
      } else this.createEmptyUserItem();
    },
    loadProjects() {
      _getAllProjectCombo().then(res => {
        if (res.data.success) this.projects = res.data.data;
      });
    },
    loadExpenseCenter() {
      _getAllExpenseCenterCombo().then(res => {
        if (res.data.success) this.expenseCenters = res.data.data;
      });
    },
    create() {
      this.$v.expense.$touch();
      if (this.$v.expense.$error) return;

      _create(this.expense).then(res => {
        if (res.data.success) this.$router.push({ name: "expenses" });
      });
    },
    update() {
      this.$v.expense.$touch();
      if (this.$v.expense.$error) return;
      _update(this.expense).then(res => {
        if (res.data.success) this.$router.push({ name: "expenses" });
      });
    },
    createEmptyUserItem() {
      this.expense = {
        id: 0, 
        expenseCode: "",
        description: "",
        requestDate: new Date(),
        amount: 0,
        approveStatus: null,
        approveDate: null,
        ownerUser: this.$store.getters.user.email,
        ownerUserId: this.$store.getters.user.userId,
        details: [
          {
            id: 0,
            expenseId: 0,
            expenseTypeId: 1,
            date: new Date(),
            expenseCenterId: null,
            projectId: null,
            description: null,
            amount: 0
          }
        ]
      };
    },
    addNewEmptyDetail() {
      this.expense.details.push({
        id: 0,
        expenseId: 0,
        date: null,
        expenseCenterId: null,
        projectId: null,
            expenseTypeId: 1,
        description: null,
        amount: 0
      });
    },
    deleteDetailItem(item) {
      this.expense.details.splice(this.expense.details.indexOf(item), 1);
      this.updateHeaderAmount();
    },
    updateHeaderAmount() {
      this.expense.amount = this.expense.details.reduce((acc, detailItem) => {
        return (acc += parseFloat(detailItem.amount));
      }, 0);
    },

    approve: function(dialog) {
      if (this.expense.id != 0) {
        _approve(this.approveItem).then(response => {
          if (response.data.success) this.$router.push({ name: "expenses" });
        });
        dialog.close();
      }
    },

    reject: function(dialog) {
      if (this.expense.id != 0) {
        _reject(this.approveItem).then(response => {
          if (response.data.success) this.$router.push({ name: "expenses" });
        });
        dialog.close();
      }
    },

    getMyApproveIfExist: function() {
      _getMyApproveIfExist({
        referenceId: this.expense.id,
        referenceType: 2
      }).then(response => {
        if (response.data.success) {
          this.approveItem = response.data.data;
        }
      });
    }
  }
};
</script>
